const configuration = {};

export default configuration;
